<script setup lang="ts">
import { repository } from "~/repository";
import { first, map } from "lodash-es";

const currentStep = defineModel<"rules-step" | "username-step" | "chat-step">(
  "currentStep",
);

const isSubmitting = ref(false);
const userName = ref("");
const submitError = ref("");

async function submit() {
  isSubmitting.value = true;

  if (!userName) {
    currentStep.value = "chat-step";
    submitError.value = "User name is required";
  } else {
    submitError.value = "";
  }

  try {
    await repository.auth.saveProfileInfo({
      user_name: userName.value,
    });
    currentStep.value = "chat-step";
  } catch (e: any) {
    submitError.value = first(map(e.response._data.errors, "detail"));
  } finally {
    isSubmitting.value = false;
  }
}
</script>

<template>
  <div class="flex flex-col justify-center bg-black p-3 text-white">
    <div class="mb-3">Please add your username to start chat !</div>
    <InputText v-model="userName" fluid />
    <div v-if="submitError" class="mt-2 text-sm text-red-500">
      {{ submitError }}
    </div>
    <Button
      placeholder="User Name"
      label="Add"
      class="mt-8 w-full"
      outlined
      :loading="isSubmitting"
      @click="submit"
    />
  </div>
</template>

<style scoped></style>
